import script from "./StepReview.vue?vue&type=script&setup=true&lang=js"
export * from "./StepReview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HelpHint from "@/components/neue/wizard/HelpHint.vue";
import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { HelpHint, HighlightedText, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HelpHint, HighlightedText, WizardSection }, script.__o.components);}